import React from 'react';
import DentalServicePage from './DentalServicePage';

const RoutineCheckupsAndCleaning = () => {
    // Defined content for Routine Checkups & Cleaning
    const serviceName = 'Routine Checkups & Cleaning';
    const serviceTagline = 'Maintain optimal oral health with regular preventive care at Wisdom Dental Clinic';

    const whatIsContent = [
        "Routine dental checkups and professional cleanings are the cornerstone of preventive dental care, designed to maintain your oral health and detect potential issues before they develop into serious problems. At Wisdom Dental Clinic, our comprehensive checkups include a thorough examination of your teeth, gums, and oral tissues, along with professional cleaning to remove plaque and tartar that regular brushing and flossing can't address.",
        'Our professional dental cleanings (prophylaxis) involve the careful removal of plaque and tartar from all surfaces of your teeth, followed by polishing to remove stains and smooth the tooth surface. Combined with a detailed dental examination, digital X-rays when necessary, and oral cancer screenings, these regular visits help ensure optimal oral health and contribute significantly to your overall well-being.',
    ];

    const whenRequiredContent = {
        paragraphs: [
            'Regular dental checkups and cleanings are essential for everyone, regardless of age or the current condition of your teeth and gums.',
        ],
        listIntro: 'Routine dental visits are particularly important if you:',
        list: [
            "Haven't seen a dentist in over 6 months",
            'Notice bleeding gums when brushing or flossing',
            "Experience bad breath that doesn't improve with brushing",
            'Have a history of cavities or gum disease',
            'Smoke or use tobacco products',
            'Have medical conditions like diabetes or heart disease',
            'Take medications that cause dry mouth',
            'Have dental restorations (fillings, crowns, implants)',
        ],
        closing:
            'Most dental professionals recommend checkups and cleanings every six months, though some patients may benefit from more frequent visits based on their specific oral health needs and risk factors.',
    };

    const howDoneContent = {
        paragraphs: [
            "At Wisdom Dental Clinic, we've elevated the standard dental checkup into a comprehensive oral health assessment, using advanced technology and a detail-oriented approach.",
        ],
        listIntro: 'Our routine checkups and cleanings include:',
        list: [
            'Digital intraoral imaging for detailed views of your teeth and gums',
            'Low-radiation digital X-rays to detect hidden decay and bone issues',
            'Advanced periodontal screening to assess gum health',
            'Professional ultrasonic and hand scaling to remove plaque and tartar',
            'Gentle polishing to remove surface stains and smooth teeth',
            'Fluoride treatment options to strengthen enamel',
            'Personalized oral hygiene instruction and product recommendations',
        ],
        closing:
            'Our dental hygienists and dentists work together to provide thorough yet gentle care, ensuring your comfort throughout the visit while delivering exceptional results that help maintain your oral health for years to come.',
    };

    const benefitsContent = [
        {
            title: 'Prevent Decay & Disease',
            description: 'Regular cleanings remove plaque that leads to cavities and gum disease',
        },
        {
            title: 'Early Problem Detection',
            description: 'Identify issues before they become painful or require extensive treatment',
        },
        {
            title: 'Fresher Breath',
            description: 'Professional cleaning removes bacteria that cause bad breath',
        },
        {
            title: 'Brighter Smile',
            description: 'Removal of surface stains helps maintain a whiter, brighter smile',
        },
        {
            title: 'Save Money',
            description: 'Preventive care costs less than treating advanced dental problems',
        },
        {
            title: 'Protect Overall Health',
            description: 'Good oral health contributes to better general health and well-being',
        },
    ];

    const procedureSteps = [
        {
            title: 'Medical History Review',
            description: 'Update your health information to ensure safe and appropriate dental care tailored to your needs',
        },
        {
            title: 'Comprehensive Examination',
            description:
                'Thorough assessment of your teeth, gums, tongue, and oral tissues, including screening for oral cancer and other abnormalities',
        },
        {
            title: 'Diagnostic Imaging',
            description:
                'Digital X-rays and intraoral images as needed to detect hidden decay, bone loss, or other issues not visible during the examination',
        },
        {
            title: 'Professional Cleaning',
            description:
                "Careful removal of plaque and tartar (calculus) from all tooth surfaces, including below the gumline where your toothbrush can't reach",
        },
        {
            title: 'Polishing & Fluoride',
            description:
                'Removal of surface stains and biofilm, followed by application of fluoride treatment to strengthen tooth enamel and prevent decay',
        },
        {
            title: 'Personalized Recommendations',
            description: 'Discussion of findings, oral hygiene instruction, and development of a treatment plan for any identified issues',
        },
    ];

    const seoData = {
        title: 'Routine Dental Checkup in Sector 23, Palam Vihar, Gurgaon',
        description:
            'Looking for the Best Dental Checkup Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Teeth Cleaning. Call now!',
        keywords:
            'Smile Makeover in Gurgaon,Best Teeth Whitening Clinic in Gurgaon,Teeth Whitening in Gurgaon,Teeth Whitening Near Me,Teeth Whitening Sector 23 gurgaon, Teeth Whitening palam vihar gurgaon',
        canonical: 'https://wisdomdentalclinics.in/checkups-cleaning',
        ogTitle: 'Routine Dental Checkup in Sector 23, Palam Vihar, Gurgaon',
        ogDescription:
            'Looking for the Best Dental Checkup Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Teeth Cleaning. Call now!',
        twitterTitle: 'Routine Dental Checkup in Sector 23, Palam Vihar, Gurgaon',
        twitterDescription:
            'Looking for the Best Dental Checkup Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable Teeth Cleaning. Call now!',
        h1Text: 'Routine Checkups & Cleaning in Sector 23 Palam Vihar Gurgaon',
    };

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
            seoData={seoData}
        />
    );
};

export default RoutineCheckupsAndCleaning;
